document.querySelectorAll('.js-toggle-password').forEach(passToggle => {
    passToggle.addEventListener('click', event => {
        const input = event.currentTarget.parentNode.querySelector('input')
        const type = input.getAttribute('type')

        input.setAttribute('type', ( type == 'text' ? 'password' : 'text' ))
        const toggleText = event.currentTarget;
        const showText = toggleText.getAttribute('data-show');
        const hideText = toggleText.getAttribute('data-hide');

        toggleText.textContent = type === 'text' ? showText : hideText;
    })
})